<template>
  <div :class="containerClass">
    <div v-if="showImageFirst" :class="rowClass">
      <slot name="image" />
      <slot name="products" />
    </div>
    <div v-else :class="rowClass">
      <slot name="products" />
      <slot name="image" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ShopTheLookBlockProps } from './ShopTheLookBlock.types';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = withDefaults(defineProps<ShopTheLookBlockProps>(), {
  wide: false,
  imagePosition: 'left',
});

const toBool = (value: boolean | string): boolean => value === true || value === 'true';

const isWide = computed(() => toBool(props.wide));
const isMobile = ref(false);

const updateMobile = (): void => {
  isMobile.value = window.matchMedia('(max-width: 767px)').matches;
};

onMounted(() => {
  updateMobile();
  window.addEventListener('resize', updateMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateMobile);
});

const showImageFirst = computed(() => props.imagePosition === 'left' || isMobile.value);

const containerClass = computed(() =>
  isWide.value
    ? 'shop-the-look__container shop-the-look__container--wide'
    : 'shop-the-look__container'
);

const rowClass = computed(() => {
  const alignment = showImageFirst.value
    ? 'shop-the-look__row shop-the-look__row--left'
    : 'shop-the-look__row shop-the-look__row--right';

  return isWide.value ? `${alignment} shop-the-look__row--wide` : alignment;
});
</script>
